import { BaseModel, DateField, enumField, ModelInstance, ToBackHook, ToFrontHook } from './util';
import { UserGender } from './user';

@ModelInstance({
  mappingFields: {
    email: 'email',
    phone: 'phone',
    gender: 'gender',
    birth_date: 'birthDate',
    size: 'size',
    nickname: 'nickname',
    city: 'city',
  },
  relation: {
    birthDate: DateField,
    gender: enumField(UserGender),
  }
})
export class TournamentJoin1x1Data extends BaseModel {
  email: string;
  phone: string;
  gender: string;
  birthDate: Date;
  size: string;
  nickname: string;
  city: string;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
